import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { LocaleService } from '../../locale/locale.service';
import { RoutesEnum } from '../../locale/routes.enum';

@Component({
  selector: 'app-features-top-card',
  templateUrl: './features-top-card.component.html',
  styleUrls: [
    './styles/features-top-card.component.scss',
    './styles/features-top-card-tablet.scss',
    './styles/features-top-card-mobile.scss',
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FeaturesTopCardComponent {

  @Input() public title: string = 'ACCOUNTING.MAIN_TITLE';
  @Input() public icon: string = '';

  constructor(
    public router: Router,
    private localeService: LocaleService
  ) {
  }

  public goToSignUpPage(): void {
    this.router.navigate([this.localeService.getLink(RoutesEnum.START)]);
  }

}
